export const messages = {
  RESET_PASSWORD_SUCCESS_MESSAGE:
    'If that email address is registered, we will send you an email to reset your password.',
  RESET_PASSWORD_SUCCESS_CLASS: 'alert alert-success',
  VERIFY_ACCOUNT_MESSAGE: 'Thank you for verifying your account. Please sign in below.',
  VERIFY_ACCOUNT_CLASS: 'alert alert-success'
}
